import { registerPlugin, Capacitor } from '@capacitor/core';

interface TimePickerResult {
  hour: number;
  minute: number;
  dismissed: boolean;
}

interface TimePickerPlugin {
  show(options: {
    hour: number;
    minute: number;
    minuteInterval: number;
    minHour?: number;
    maxHour?: number;
  }): Promise<TimePickerResult>;
}

const TimePicker = registerPlugin<TimePickerPlugin>('TimePicker');

/**
 * Show native time picker on iOS (barrel wheel with minuteInterval).
 * Optionally restrict to minHour..maxHour range.
 * Returns null if dismissed or not on native platform.
 */
export async function showTimePicker(
  hour: number,
  minute: number,
  minuteInterval = 5,
  minHour?: number,
  maxHour?: number,
): Promise<{ hour: number; minute: number } | null> {
  if (!Capacitor.isNativePlatform()) return null;
  const result = await TimePicker.show({ hour, minute, minuteInterval, minHour, maxHour });
  if (result.dismissed) return null;
  return { hour: result.hour, minute: result.minute };
}
